import React from "react";
import DoctorLayout from "../../../components/Layout/DoctorLayout-new";
import LayoutWithbg from "../../../components/LayoutWithbg";
import { BillingPermissionsProvider } from "../useBillingPermissions";

/** Wraps IPD Billing pages with the app navbar + page background, keeping IPD sidebar inside. */
export default function IPDBillingAppShell({ setSearchText, children }) {
  return (
    <DoctorLayout setSearchText={setSearchText}>
      <BillingPermissionsProvider>
        <LayoutWithbg>{children}</LayoutWithbg>
      </BillingPermissionsProvider>
    </DoctorLayout>
  );
}
